/**
 * Component Registry for The Fletcher 
 * 
 * Inherits from @vibesites-sunrise-management/theme-preferred and allows property-specific overrides.
 */

import type { ComponentRegistry } from '@vibesites/runtime';
import { registry as parentRegistry } from '@vibesites-sunrise-management/theme-preferred/registry';
import { GalleryHero } from './components/GalleryHero';
import { Hero } from './components/Hero';
import { PropertyOverview } from './components/PropertyOverview';

/**
 * Property-specific component overrides.
 */
const propertyOverrides: Partial<ComponentRegistry> = {
  GalleryHero,
  Hero,
  PropertyOverview,
};

/**
 * Final merged registry for this property.
 * Inherits all components from the parent theme, with property overrides.
 */
export const registry: ComponentRegistry = {
  ...parentRegistry,
  ...propertyOverrides,
};

export default registry;
